export default __webpack_public_path__ + "static/media/grey_rocket.b6eb9beb.svg";